import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Box } from "@mui/material";
import { useIsAuthenticatedEmployee } from "./hooks";
import { ShipmentsModule, OrdersModule } from "./modules";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";

const rootContainerStyles = {
  margin: "4px",
};

export const Root = () => {
  const queryClient = new QueryClient();

  const IsNotAuthenticatedUser = () => {
    return <>User not authenticated properly. Tip: Access this page via proper login channels.</>;
  };

  if (!useIsAuthenticatedEmployee()) {
    return <IsNotAuthenticatedUser />;
  }

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/shipments" element={<ShipmentsModule />} errorElement={<>Error loading shipments page</>} />
        <Route path="/orders" element={<OrdersModule />} errorElement={<>Error loading orders page</>} />
      </>
    )
  );

  return (
    <QueryClientProvider client={queryClient}>
      <Box sx={rootContainerStyles}>
        <RouterProvider router={router} />
      </Box>
    </QueryClientProvider>
  );
};
